import { Button, Card, InlineStack, Text } from "@shopify/polaris";
import { useSearchParams } from "react-router-dom";

import { t } from "../../lib/i18n";

export function PurchaseOrderModeSwitch({
  active,
  confirmLeave,
}: {
  active: "saved" | "new";
  confirmLeave?: () => boolean;
}) {
  const [, setSearchParams] = useSearchParams();

  const switchMode = (mode: "saved" | "new") => {
    if (mode !== active && confirmLeave && !confirmLeave()) return;
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      next.delete("draft");
      if (mode === "saved") next.set("view", "saved");
      else next.delete("view");
      return next;
    });
  };

  return (
    <Card>
      <InlineStack gap="200" blockAlign="center" wrap>
        <Text as="span" variant="headingSm">
          {t("表示する注文書")}
        </Text>
        <Button
          variant={active === "saved" ? "primary" : "secondary"}
          onClick={() => switchMode("saved")}
        >
          {t("保存済み下書き")}
        </Button>
        <Button
          variant={active === "new" ? "primary" : "secondary"}
          onClick={() => switchMode("new")}
        >
          {t("新しい注文書（既存提案）")}
        </Button>
      </InlineStack>
    </Card>
  );
}
